export default __webpack_public_path__ + "static/media/op.1d3b21bb.svg";